/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const LabelWithTooltip = ({ label, tooltip, align = 'center' }) => (
  <div style={{ textAlign: align }}>
    {label}
    <Tooltip placement="top" title={tooltip}>
      <QuestionCircleOutlined className="ml-1 text-secondary" />
    </Tooltip>
  </div>
);

LabelWithTooltip.propTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.node.isRequired,
  align: PropTypes.oneOf(['left', 'center', 'right'])
};

export default LabelWithTooltip;
